/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { NewServico } from '../model/newServico';
import { Servico } from '../model/servico';
import { UpdServico } from '../model/updServico';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';

@Injectable()
export class ServicoApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Listar Serviços do Cliente
     * 
     * @param clienteId 
     * @param withoutChildren 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ServicoClienteClienteIdGet(clienteId: number, withoutChildren?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Servico>>;
    public v1ServicoClienteClienteIdGet(clienteId: number, withoutChildren?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Servico>>>;
    public v1ServicoClienteClienteIdGet(clienteId: number, withoutChildren?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Servico>>>;
    public v1ServicoClienteClienteIdGet(clienteId: number, withoutChildren?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1ServicoClienteClienteIdGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Servico>>('get',`${this.basePath}/v1/servico/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Novo Serviço
     * 
     * @param clienteId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ServicoClienteClienteIdPost(clienteId: number, body?: NewServico, observe?: 'body', reportProgress?: boolean): Observable<Servico>;
    public v1ServicoClienteClienteIdPost(clienteId: number, body?: NewServico, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Servico>>;
    public v1ServicoClienteClienteIdPost(clienteId: number, body?: NewServico, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Servico>>;
    public v1ServicoClienteClienteIdPost(clienteId: number, body?: NewServico, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1ServicoClienteClienteIdPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Servico>('post',`${this.basePath}/v1/servico/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Serviços
     * 
     * @param withoutChildren 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ServicoGet(withoutChildren?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Servico>>;
    public v1ServicoGet(withoutChildren?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Servico>>>;
    public v1ServicoGet(withoutChildren?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Servico>>>;
    public v1ServicoGet(withoutChildren?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Servico>>('get',`${this.basePath}/v1/servico`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Serviço
     * 
     * @param servicoId 
     * @param clienteId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ServicoServicoIdClienteClienteIdPut(servicoId: number, clienteId: number, body?: UpdServico, observe?: 'body', reportProgress?: boolean): Observable<Servico>;
    public v1ServicoServicoIdClienteClienteIdPut(servicoId: number, clienteId: number, body?: UpdServico, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Servico>>;
    public v1ServicoServicoIdClienteClienteIdPut(servicoId: number, clienteId: number, body?: UpdServico, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Servico>>;
    public v1ServicoServicoIdClienteClienteIdPut(servicoId: number, clienteId: number, body?: UpdServico, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (servicoId === null || servicoId === undefined) {
            throw new Error('Required parameter servicoId was null or undefined when calling v1ServicoServicoIdClienteClienteIdPut.');
        }

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1ServicoServicoIdClienteClienteIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Servico>('put',`${this.basePath}/v1/servico/${encodeURIComponent(String(servicoId))}/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Serviço
     * 
     * @param servicoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ServicoServicoIdDelete(servicoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1ServicoServicoIdDelete(servicoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1ServicoServicoIdDelete(servicoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1ServicoServicoIdDelete(servicoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (servicoId === null || servicoId === undefined) {
            throw new Error('Required parameter servicoId was null or undefined when calling v1ServicoServicoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/servico/${encodeURIComponent(String(servicoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Serviço pelo Id
     * 
     * @param servicoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ServicoServicoIdGet(servicoId: number, observe?: 'body', reportProgress?: boolean): Observable<Servico>;
    public v1ServicoServicoIdGet(servicoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Servico>>;
    public v1ServicoServicoIdGet(servicoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Servico>>;
    public v1ServicoServicoIdGet(servicoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (servicoId === null || servicoId === undefined) {
            throw new Error('Required parameter servicoId was null or undefined when calling v1ServicoServicoIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Servico>('get',`${this.basePath}/v1/servico/${encodeURIComponent(String(servicoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
